import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SliderBox, SliderMenu } from "..";
import { fetchMySoldOpuses } from "../../../reducks/opuses/operations";
import { getMyOpuses } from "../../../reducks/opuses/selectors";
// import { getUserId } from "../../../reducks/users/selectors";

const OpusBox = (props) => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  // const uid = getUserId(selector);
  const opuses = getMyOpuses(selector);
  const opusData = props.opusData;
  const [soldIdArray, setSoldIdArry] = useState([]);
  // console.log(opuses);
  // console.log(soldIdArray);

  const opusesIdSet = (opuses) => {
    let idArry = [];
    opuses.map((opus) => idArry.push(opus.id));
    setSoldIdArry(idArry);
  };

  useEffect(() => {
    if (typeof props.organzerId !== "undefined") {
      dispatch(fetchMySoldOpuses(props.organzerId));
    }
    // eslint-disable-next-line
  }, [props.organzerId]);
  useEffect(() => {
    opusesIdSet(opuses);
    // eslint-disable-next-line
  }, [opuses]);

  return (
    <div className="back-red">
      {React.Children.toArray(
        opusData.map((images) => (
          <div className="center-box center">
            {images.name}
            <SliderBox images={images.images} />
            <div className="spacer-box--sss"></div>

            <SliderMenu
              id={images.id}
              key={images.name}
              name={images.name}
              price={images.price}
              size={images.size}
              description={images.description}
              images={images.images}
              boothId={props.boothId}
              uid={images.uid}
              isSold={soldIdArray.includes(images.id)}
            />
          </div>
        ))
      )}
    </div>
  );
};
export default OpusBox;
